// src/environment/environment.dev.js
const environment = {
    API_URL: "https://elexyt2024.site/",
}

export default environment;
